import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';

import { KYMW4400Component } from './kymw4400.component';
import { KYMW0D00Module } from '../../../commons/kymw0d/kymw0d00/kymw0d00.module';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import '@grapecity/wijmo.touch';
import { CopyPageInfoToCoopsService } from '../kymw4402/api-services/copy-page-info-to-coops.service';
import { GetFeatureThemaSelectItemsService } from './api-services/get-feature-thema-select-items.service';
import { GetPageInfoListService } from './api-services/get-page-info-list.service';
import { GetPageTemplateSelectItemsService } from './api-services/get-page-template-select-items.service';
import { GetPublishGoodsGroupSelectItemsService } from './api-services/get-publish-goods-group-select-items.service';
import { GetUserManagementSelectItemsService } from './api-services/get-user-management-select-items.service';
import { OutputPageInfoCsvService } from './api-services/output-page-info-csv.service';
import { RegistPageInfoListService } from './api-services/regist-page-info-list.service';
import { RegistAutoKomaArrangeService } from './api-services/regist-auto-koma-arrange.service';
import { GetCodeListService } from '../../../commons/kymw02/api-services/get-code-list.service';
import { GetTagListService } from './api-services/get-tag-list.service';
import { GetAutoKomaArrangePatternListService } from './api-services/get-auto-koma-arrange-pattern-list.service';
import { KYMW4401Module } from '../kymw4401/kymw4401.module';
import { KYMW4402Module } from '../kymw4402/kymw4402.module';
import { KYMW4403Module } from '../kymw4403/kymw4403.module';
import { KYMW0002Module } from '../../../commons/kymw00/kymw0002/kymw0002.module';

/**
 * ページ・台割編集画面 モジュール設定クラス
 *
 * @export KYMW4400Module
 * @class KYMW4400Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjInputModule,
    KYMW0D00Module,
    KYMW4401Module,
    KYMW4402Module,
    KYMW4403Module,
    KYMW0002Module,
  ],
  declarations: [KYMW4400Component],
  providers: [
    CopyPageInfoToCoopsService,
    GetFeatureThemaSelectItemsService,
    GetPageInfoListService,
    GetPageTemplateSelectItemsService,
    GetPublishGoodsGroupSelectItemsService,
    GetUserManagementSelectItemsService,
    OutputPageInfoCsvService,
    RegistPageInfoListService,
    RegistAutoKomaArrangeService,
    GetCodeListService,
    GetTagListService,
    GetAutoKomaArrangePatternListService,
  ],
})
export class KYMW4400Module {}
